import PageHeader from "@/components/common/PageHeader";
import { Briefcase, LockKeyhole } from "lucide-react";

export default function PartnerLandingPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Partner Console"
        subtitle="Channel-partner access is isolated from platform administration."
      />
      <div className="grid gap-4 md:grid-cols-2">
        <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <Briefcase className="h-6 w-6 text-blue-600" />
          <h2 className="mt-4 font-bold text-slate-900">Partner workspace</h2>
          <p className="mt-2 text-sm text-slate-500">
            Partner-specific tenants, referrals, commissions and payouts will be
            surfaced here as scoped capabilities are assigned.
          </p>
        </section>
        <section className="rounded-2xl border border-slate-200 bg-slate-50 p-6">
          <LockKeyhole className="h-6 w-6 text-slate-500" />
          <h2 className="mt-4 font-bold text-slate-900">
            Restricted by default
          </h2>
          <p className="mt-2 text-sm text-slate-500">
            Platform tenant, billing, security and operations controls remain
            unavailable to channel-partner identities.
          </p>
        </section>
      </div>
    </div>
  );
}
